"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as e } from "react";
import a from "../components/Icon/SvgIcon.js";
const m = (l) => /* @__PURE__ */ o(
  a,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.637 17.83c1.81 2.21 4.94 3.48 8.58 3.48a25 25 0 0 0 6.01-.73.65.65 0 0 0 .4-.45l1.54-6.55a.61.61 0 0 0-.94-.65 8 8 0 0 1-4.58 1.52 3.64 3.64 0 0 1-2.81-1.1 1.88 1.88 0 0 1-.39-1.58c.32-1.61 2.32-2.91 4.44-2.91a6 6 0 0 1 4 1.61.61.61 0 0 0 .62.11.62.62 0 0 0 .4-.48l1.09-6.66a.63.63 0 0 0-.44-.7 20 20 0 0 0-5.41-.74c-6.76 0-12.9 4.26-13.98 9.7a7.24 7.24 0 0 0 1.47 6.13m-.26-5.89c.97-4.88 6.63-8.71 12.77-8.71a18.3 18.3 0 0 1 4.53.5l-.84 5.09a6.9 6.9 0 0 0-3.92-1.26c-2.73 0-5.21 1.72-5.65 3.91a3.12 3.12 0 0 0 .65 2.6 4.78 4.78 0 0 0 3.76 1.56 8.75 8.75 0 0 0 4-1l-1.13 4.81a25.4 25.4 0 0 1-5.33.56c-3.27 0-6.05-1.07-7.63-3a6 6 0 0 1-1.21-5.06",
        clipRule: "evenodd"
      }
    )
  }
), i = e(m);
export {
  i as Home,
  i as default
};
